import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//import loadable from "@loadable/component";
import allActions from "../../state/actions";
import Layout from "../../components/layout/Layout";
import PreloaderBg from "../../components/shared/preloaderBg/PreloaderBg";
import BloccoCategorieHome from "../../components/homepage/bloccoCategorieHome/BloccoCategorieHome";
import BloccoBannerHome from "../../components/homepage/bloccoBannerHome/BloccoBannerHome";
import BloccoPiuVendutiHome from "../../components/homepage/bloccoPiuVendutiHome/BloccoPiuVendutiHome";
import BloccoInspirationHome from "../../components/homepage/bloccoInspirationHome/BloccoInspirationHome";
import BloccoCategorieSlideHome from "../../components/homepage/bloccoCategorieSlideHome/BloccoCategorieSlideHome";
import BloccoChisiamoHome from "../../components/homepage/bloccoChisiamoHome/BloccoChisiamoHome";
import BloccoMagazineHome from "../../components/homepage/bloccoMagazineHome/BloccoMagazineHome";

import ModalConfirm from "../../components/shared/modalConfirm/ModalConfirm";
import { BASENAME } from "../../utils/basename";

const Homepage = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector((state) => state.currentPage);
  const user = useSelector((state) => state.user);
  const headerStatic = useSelector((state) => state.headerStatic);
  const homepageStatic = useSelector((state) => state.staticPages.homepage);
  const productsBestSoldHome = useSelector(
    (state) => state.productsBestSoldHome
  );
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const isFetching = currentPage.isFetching;

  const [popupshown, setPopupshown] = useState(false);

  useEffect(() => {
    // controllo nello store se ho già il dettaglio di homepage
    const homepagePage = homepageStatic;

    //console.log('homepage');

    if (homepagePage) {
      // setto i metatags
      document.title = homepageStatic.metaTitle;
      document.getElementsByTagName("META")[2].content =
        homepageStatic.metaDesc;

      const suffissoLang = currentPage.currentLang.replace("_", "");
      const htmlModalDynamic = (
        <div className="relative">
          <img
            src={`${BASENAME}/images/banner-chiusura.webp`}
            width="500"
            height="300"
            className="flex-start relative"
            alt=""
          />
          <span
            className="absolute left-1/2 right-0 top-0 bottom-0 flex items-center p-3 text-sm xl:text-md text-white"
            dangerouslySetInnerHTML={{
              __html: genericheTranslation.bannerchiusura.itemName,
            }}
          ></span>
        </div>
      );

      const htmlModal = (
        <div className="relative">
          <img
            src={`${BASENAME}/images/bannerchiusura_${suffissoLang}.jpg`}
            width="600"
            height="600"
            className="flex-start relative"
            alt=""
          />
        </div>
      );

      //let popup_stop = new Date('2022-09-01');
      //let popup_stop = new Date("2022-08-29");
      //let popup_stop = new Date("2023-08-28");
      let popup_stop = new Date("2025-08-28");
      let today = new Date();

      if (!window.sessionStorage.getItem("popupshown") && today < popup_stop) {
        sessionStorage.setItem("popupshown", true);
        ModalConfirm({
          titleToShow: "",
          messageToShow: htmlModal,
          isShowConfirmButton: false,
          isShowCanceButton: false,
          isTimerModal: false,
          isShowCloseButton: true,
          textConfirmButton: "",
          textCancelButton: "",
          customClassContainer: "modalHomepage",
        });
      }
    }

    // controllo di avere almeno productsBestSoldHome nello store, altrimenti chiamo action creator fetchHomepage che recupera tutti i dati della homepage
    if (productsBestSoldHome.length === 0) {
      // chiamo web service
      setTimeout(
        () =>
          dispatch(
            allActions.homepageActions.fetchHomepage(
              currentPage.currentLang,
              user?.userData?.id
            )
          ),
        50
      );
    } else {
      // loading...
      dispatch(allActions.isFetchingAction.loadStoredData());

      // carico i dati dallo store se arrivo da un'altra pagina
      dispatch(
        allActions.homepageActions.loadHomepage(
          headerStatic[0],
          homepageStatic.metaTitle,
          homepageStatic.metaDesc
        )
      );
    }
  }, [homepageStatic]);

  return (
    <Layout>
      <PreloaderBg showPreloader={isFetching} />
      <BloccoCategorieHome />
      <BloccoBannerHome />
      <BloccoPiuVendutiHome />
      <BloccoInspirationHome />
      <BloccoCategorieSlideHome />
      <BloccoChisiamoHome />
      <BloccoMagazineHome />
    </Layout>
  );
};

export default Homepage;
